import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { BLOG_POSTS, BRAND } from '../data/siteContent';

export default function BlogPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">Blog</span>
          <h1>Guides from {BRAND.name}</h1>
          <p>Practical articles on GED prep, study plans, AI practice exams, and weekly learning rhythm.</p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <div className="mk-blog-grid">
            {BLOG_POSTS.map((p) => (
              <article key={p.slug} className="mk-blog-card">
                <div className="mk-blog-card-icon">
                  <span className="material-symbols-outlined">{p.icon}</span>
                </div>
                <span className="mk-blog-meta">
                  {p.category} · {p.readMins} min · {p.date}
                </span>
                <h2>
                  <Link to={`/blog/${p.slug}`}>{p.title}</Link>
                </h2>
                <p>{p.excerpt}</p>
                <Link to={`/blog/${p.slug}`} className="mk-text-link">
                  Read article <span className="material-symbols-outlined">arrow_forward</span>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
